import { render, staticRenderFns } from "./waitHouse.vue?vue&type=template&id=6b15ea90&"
import script from "./waitHouse.vue?vue&type=script&lang=js&"
export * from "./waitHouse.vue?vue&type=script&lang=js&"
import style0 from "./waitHouse.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports